import {Col, Divider, Form, Input, Row, Select} from "antd";
import {useGetCategoriesQuery, useGetCitiesQuery} from "../../../store/api/CategoryApi";
import React from "react";
import {PartnerCreateDTO} from "../../../types/partner/PartnerCreateDTO";
import {AddressDTO} from "../../../types/partner/AddressDTO";
import {PartnerDTO} from "../../../types/partner/PartnerDTO";
import {StreetDTO} from "../../../types/partner/StreetDTO";
// import {useGetCitiesQuery} from "../../../store/api/CityApi";

const {TextArea} = Input

interface PartnerCreateFormProps {
    partner: PartnerDTO | undefined
    onFinish: (data: PartnerCreateDTO) => void
}

const PartnerCreateForm: React.FC<PartnerCreateFormProps> = ({partner, onFinish}) => {
    const [form] = Form.useForm()
    const {data: categories} = useGetCategoriesQuery({
        page: 1,
        size: 20
    })
    const {data: cities} = useGetCitiesQuery({
        page: 1,
        size: 20
    })

    const onFinishHandler = async (values: any) => {
        const selectedCity = cities?.data?.find(city => city.id === values.streetCity);

        const street: StreetDTO = {
            name: values.streetName === partner?.address.street.name ? null : values.streetName.trim(),
            city: selectedCity?.name === partner?.address.street.city ? "" : selectedCity?.name 

        }
        const address: AddressDTO = {
            street: street,
            city_id: values.city_id === partner?.address.city_id ? null : values.city_id,
            house: values.house === partner?.address.house ? null : values.house.trim(),
            latitude: values.point.substring(0, values.point.indexOf(',')) === partner?.address.latitude ? null : values.point.substring(0, values.point.indexOf(',')),
            longitude: values.point.substring(values.point.indexOf(' ') + 1) === partner?.address.longitude ? null : values.point.substring(values.point.indexOf(' ') + 1),
            comment: values.comment === partner?.address.comment ? null : values.comment.trim()
        }
        const dto: PartnerCreateDTO = {
            name: values.name === partner?.name ? null : values.name.trim(),
            coupon_name: values.couponName === partner?.coupon_name ? null : values.couponName.trim(),
            coupon_percent: values.couponPercent === partner?.coupon_percent ? null : values.couponPercent,
            category_id: values.categoryId === partner?.category.id ? null : values.categoryId,
            address: address
        }
        onFinish(dto)
    }

    return (
        <Form form={form} onFinish={onFinishHandler} id={'partner-create-form'} layout="vertical"
              initialValues={{
                  name: partner?.name,
                  categoryId: partner?.category.id,
                  couponName: partner?.coupon_name,
                  couponPercent: partner?.coupon_percent,
                  city_id: partner?.address.city_id,
                  streetName: partner?.address.street.name,
                  streetCity: partner?.address.street.city,
                  house: partner?.address.house,
                  point: partner ? `${partner?.address.latitude}, ${partner?.address.longitude}` : undefined,
                  comment: partner?.address.comment
              }}>
            <Row gutter={12}>
                <Col span={12}>
                    <Form.Item
                        name="name"
                        label="Название"
                        rules={[{required: true, whitespace: true, message: "Введите название"}]}
                    >
                        <Input placeholder={'Введите название'}/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="categoryId"
                        label="Категория"
                        rules={[{required: true, message: "Выберите категорию"}]}
                    >
                        <Select
                            placeholder={'Выберите категорию'}
                            options={categories?.data?.content.map(item => ({
                                value: item.id,
                                label: item.name
                            }))}
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={12}>
                <Col span={12}>
                    <Form.Item
                        name="couponName"
                        label="Купон"
                        rules={[{required: true, whitespace: true, message: "Введите название купона"}]}
                    >
                        <Input placeholder={'Введите название'}/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="couponPercent"
                        label="Процентная ставка"
                        rules={[{
                            required: true,
                            pattern: /^-?[0-9][0-9]?$|^100$/,
                            message: "Введите процент купона (мин.: -100, макс.: 100)"
                        }]}
                    >
                        <Input placeholder={'Введите процент'}/>
                    </Form.Item>
                </Col>
            </Row>
            <Divider>Адрес</Divider>
            <Row gutter={12}>
                <Col span={12}>
                    <Form.Item
                        name="streetName"
                        label="Название улицы"
                        rules={[{required: true, whitespace: true, message: "Введите название улицы"}]}
                    >
                        <Input placeholder={'Введите название'}/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="city_id"
                        label="Город"
                        rules={[{required: true, message: "Выберите город"}]}
                    >
                        <Select
                            placeholder={'Выберите город'}
                            options={cities?.data?.map(item => ({
                                value: item.id,
                                label: item.name
                            }))}
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={12}>
                <Col span={12}>
                    <Form.Item
                        name="point"
                        label="Локация"
                        rules={[{
                            required: true,
                            pattern: /^(-?\d+(\.\d+)?), \s*(-?\d+(\.\d+)?)$/,
                            message: "Введите локацию по шаблону (Пр.: 41.345570, 69.284599)"
                        }]}
                    >
                        <Input placeholder={'41.345570, 69.284599'}/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="house"
                        label="Дом"
                        rules={[{
                            required: true,
                            message: "Введите номер дома"
                        }]}
                    >
                        <Input placeholder={'Введите номер дома'}/>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <Form.Item
                        name="comment"
                        label="Комментария к адресу"
                    >
                        <TextArea placeholder="Введите комментарию" rows={4}/>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    )
}

export default PartnerCreateForm